export const projects = [
  {
    id: 1,
    title: "ES-Dedupe – Elasticsearch Data Deduplication Tool",
    description: "Python CLI tool to detect & remove duplicate documents in large Elasticsearch indices using sliding-window strategy for low memory usage. Dockerized for easy deployment. Handles multi-million records while preserving index integrity.",
    tags: ["Python", "Elasticsearch", "Docker", "CLI"],
    githubUrl: "https://github.com/VaibhavUpadhyay16/ES-Dedupe",
    icon: "FaSearch", 
  },
  {
    id: 2,
    title: "AI Career Mentor – Full-Stack GenAI Platform",
    description: "React + Node + MongoDB career guidance app with OpenAI/Gemini integration for personalized paths, skill roadmaps, recommendations. Features JWT auth, avatar uploads, role-based access, and career history tracking.",
    tags: ["React", "Node.js", "MongoDB", "Gemini", "JWT"],
    githubUrl: "https://github.com/VaibhavUpadhyay16/ai-career-mentor",
    icon: "FaRobot",
  },
  {
    id: 3,
    title: "Flask–React Full Stack Template",
    description: "Production-ready starter with React (TypeScript + Tailwind), Flask backend, SQLAlchemy, RESTful CRUD APIs, JWT auth. Open-source with GitHub Actions CI and clean Git workflow.",
    tags: ["Flask", "React", "TypeScript", "Tailwind CSS", "SQLAlchemy", "REST"],
    githubUrl: "https://github.com/VaibhavUpadhyay16/flask-react-template",
    icon: "FaCodeBranch",
  },

];
export const clientWork = [
  {
    id: 1,
    title: 'Live-Chat-Application',
    description: 'A Full Flaged website to my local city Business Man for his Business which have different cart and it mainly fully functional. By this Project I have learn deep insights of React.js make custom hooks and push to npm which other users also can use later.',
    icon: 'FaComments',
    gradient: 'from-blue-500 to-purple-600',
    tags: ['React', 'Tailwind', 'Mail.JS/GSAP'],
    liveUrl: 'https://krishnagroups.netlify.app/',
  },
  {
    id: 2,
    title: 'Quiz Application',
    description: 'A Quiz Platform make with Java, Spring-Boot and Java Swing. Mainly this Project make with the help of AI and during this i learn the proper prompt writing to give instructions to the AI and most important learn how to manage bugs and debug the code.',
    icon: 'FaRobot',
    gradient: 'from-green-500 to-teal-600',
    tags: ['Java', 'Java Swing', 'AI'],
    githubUrl: 'https://github.com/Divyansh-132006/Quiz-Application-by-Team-Byte-Us',
  },
];

export const skills = [
  { name: 'HTML', icon: 'FaHtml5', color: 'text-orange-500' },
  { name: 'CSS', icon: 'FaCss3Alt', color: 'text-blue-500' },
  { name: 'JavaScript', icon: 'FaJs', color: 'text-yellow-400' },
  { name: 'Java', icon: 'FaJava', color: 'text-yellow-600' },
  { name: 'React', icon: 'FaReact', color: 'text-blue-400' },
  { name: 'Node.js', icon: 'FaNode', color: 'text-green-500' },
  { name: 'MongoDB', icon: 'FaDatabase', color: 'text-green-600' },
  { name: 'MySQL', icon: 'FaDatabase', color: 'text-green-600' },
];

export const learningJourney = [
  {
    title: "B.Tech in Computer Science & Engineering",
    description: "ABES Institute of Technology (ABESIT), Ghaziabad • 2021 – 2025\nFocused on core CS fundamentals, DSA, OOP, web technologies, and building practical projects.",
    icon: "FaGraduationCap",
    date: "2021 – Present",
  },
  {
    title: "Frontend Development Intern",
    description: "EDUNET • July 2024 – August 2024\nWorked on live EdTech platform: course pages, articles, course creation, admin/user auth, login flows, and responsive UI.",
    icon: "FaBriefcase",
    date: "Jul – Aug 2024",
  },
  {
    title: "Infosys Springboard – Software Development Internship Certification",
    description: "Completed hands-on software development training with real-world scenarios.",
    icon: "FaCertificate",
  },
  {
    title: "Java Programming Certification – Apna College",
    description: "Strengthened core Java skills, OOP concepts, and problem-solving.",
    icon: "FaCertificate",
  },
  {
    title: "Hack The Mountain 3.0 & Other Hackathons",
    description: "Participated in hackathons to build under pressure, collaborate, and ship features quickly.",
    icon: "FaTrophy",
  },
  {
    title: "Projects & Open Source",
    description: "Built ES-Dedupe (Python/Elasticsearch/Docker), AI Career Mentor (MERN + LLM), Flask-React Template (TypeScript/Tailwind).\nContributed to open-source on GitHub & Telegram.",
    icon: "FaCode",
  },
];

export const socialLinks = [
  {
    name: 'Email',
    url: 'mailto:vaibhavupadhyay116@gmail.com',
    icon: 'FaEnvelope',
    gradient: 'from-blue-500 to-purple-600',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/vaibhav-upadhyay-78436b221/',
    icon: 'FaLinkedin',
    gradient: 'from-blue-600 to-blue-800',
  },
  {
    name: 'GitHub',
    url: 'https://github.com/VaibhavUpadhyay16',
    icon: 'FaGithub',
    gradient: 'from-gray-700 to-gray-900',
  },
];
